import { enableProdMode, LOCALE_ID, ErrorHandler, APP_INITIALIZER, Injector, importProvidersFrom } from "@angular/core";

import { appInit } from "./app/app.module";
import { environment } from "./environments/environment";
import { CookieService } from "ngx-cookie-service";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { EforsyningHttpInterceptor } from "@e-forsyning/common/http";
import { ENV, LOGGER, LogentriesLoggerService } from "@dffedb/util";
import { EforsyningErrorHandler } from "@e-forsyning/common/error";
import { DEFAULT_MATOMO_SITE_ID, initMatomoFromUmbraco } from "@e-forsyning/common/matomo";
import { EBoksTilmeldingModule } from "@e-forsyning/common/e-boks";
import { KontaktoplysningerPopupModule } from "@e-forsyning/common/kontaktoplysninger-popup";
import { AktuelBrugersInstallationerService } from "@e-forsyning/common/installation/aktuel-brugers-installationer.service";
import { EforsyningSidenavMenuModule } from "@e-forsyning/common/eforsyning-menu";
import { APP_SHELL_LAYOUT_OPTIONS, AppShellModule } from "@e-forsyning/common/app-shell";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { PushNotificationService, DocumentNotificationService, TaskbarBadgeService } from "@e-forsyning/common/push-notification";
import { AppRoutingModule } from "./app/app-routing.module";
import { provideAnimations } from "@angular/platform-browser/animations";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDffDateModule, DffSimpelDialogModule } from "@dffedb/ui";
import { EForsyningFeaturesDefaultModule } from "@e-forsyning/features/default";
import { EForsyningLogindKnapModule, DffedbCookieConsentModule, DffedbDriftsstatusKnapModule, DffedbFancyboxModule } from "@e-forsyning/web-components";
import { provideServiceWorker } from "@angular/service-worker";
import { AppComponent } from "./app/app.component";
import { provideMatomo, withRouter } from "ngx-matomo-client";

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            AppShellModule,
            BrowserModule,
            AppRoutingModule,
            HttpClientModule,
            MatButtonModule,
            MatIconModule,
            MatSnackBarModule,
            MatDffDateModule,
            DffSimpelDialogModule,
            EForsyningFeaturesDefaultModule,
            EforsyningSidenavMenuModule,
            EBoksTilmeldingModule,
            KontaktoplysningerPopupModule,
            EForsyningLogindKnapModule,
            DffedbCookieConsentModule,
            DffedbDriftsstatusKnapModule,
            DffedbFancyboxModule
        ),
        CookieService,
        {
            provide: LOCALE_ID,
            useValue: "da"
        },
        {
            provide: APP_SHELL_LAYOUT_OPTIONS,
            useValue: { hiddenMenuAliases: ["oversigtskort"] }
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EforsyningHttpInterceptor,
            multi: true
        },
        {
            provide: ENV,
            useValue: environment
        },
        {
            provide: LOGGER,
            useClass: LogentriesLoggerService
        },
        {
            provide: ErrorHandler,
            useClass: EforsyningErrorHandler
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            deps: [Injector],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initMatomoFromUmbraco,
            deps: [Injector],
            multi: true
        },
        provideMatomo(
            {
                siteId: DEFAULT_MATOMO_SITE_ID,
                trackerUrl: environment.matomoUrl
            },
            withRouter()
        ),
        AktuelBrugersInstallationerService,
        PushNotificationService,
        DocumentNotificationService,
        TaskbarBadgeService,
        provideAnimations(),
        provideServiceWorker("/ngsw-worker.js", {
            enabled: (() => {
                if (typeof window === "undefined") {
                    return false;
                }

                if (typeof (window as any).Capacitor !== "undefined") {
                    const Capacitor = (window as any).Capacitor;
                    if (Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
                        return false;
                    }
                }

                const hostname = window.location.hostname;
                const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1" || hostname.endsWith(".localhost");
                const isHttps = window.location.protocol === "https:";

                if (isLocalhost && isHttps) {
                    return true;
                }

                if (hostname.match(/^172\.|^192\.168\.|^10\./)) {
                    return false;
                }

                return true;
            })(),
            registrationStrategy: typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent) ? "registerImmediately" : "registerWhenStable:30000",
            scope: "/"
        })
    ]
}).catch((err) => console.error(err));
